import React from 'react';

import Grid from '@material-ui/core/Grid';

function Power() {
  return (
    <Grid justify="center" container>
      <span className="h3Style">Potência</span>
    </Grid>
  );
}

export default Power;
